export type PaintingInfo = {
  title: string;
  artist: string;
  year: string;
  medium: string;
  dimensions: string;
  location: string;
  description: string;
};

type TranslationFunction = (key: string) => string;

export const getPaintingData = (
  t: TranslationFunction,
): Record<string, PaintingInfo> => ({
  monalisa: {
    title: t("paintings.monalisa.title"),
    artist: "Leonardo da Vinci",
    year: "1503-1519",
    medium: t("paintings.monalisa.medium"),
    dimensions: "77 cm × 53 cm",
    location: t("paintings.monalisa.location"),
    description: t("paintings.monalisa.description"),
  },
  mondrian1: {
    title: t("paintings.mondrian1.title"),
    artist: "Piet Mondrian",
    year: "1930",
    medium: t("paintings.mondrian1.medium"),
    dimensions: "46 cm × 46 cm",
    location: t("paintings.mondrian1.location"),
    description: t("paintings.mondrian1.description"),
  },
  vangogh: {
    title: t("paintings.vangogh.title"),
    artist: "Vincent van Gogh",
    year: "1889",
    medium: t("paintings.vangogh.medium"),
    dimensions: "73.7 cm × 92.1 cm",
    location: t("paintings.vangogh.location"),
    description: t("paintings.vangogh.description"),
  },
  stanczyk: {
    title: "Stańczyk",
    artist: "Jan Matejko",
    year: "1862",
    medium: t("paintings.stanczyk.medium"),
    dimensions: "88 cm × 120 cm",
    location: t("paintings.stanczyk.location"),
    description: t("paintings.stanczyk.description"),
  },
  the_scream: {
    title: t("paintings.theScream.title"),
    artist: "Edvard Munch",
    year: "1893",
    medium: t("paintings.theScream.medium"),
    dimensions: "91 cm × 73.5 cm",
    location: t("paintings.theScream.location"),
    description: t("paintings.theScream.description"),
  },
});

export const paintingLabels = (t: TranslationFunction) => ({
  medium: t("paintings.labels.medium"),
  dimensions: t("paintings.labels.dimensions"),
  location: t("paintings.labels.location"),
});
